var otsAccountOpenFactory = function ($q, $http, $log) {
    //check if user exists
    var authenticateOTSUserURL = "rest/nonauth/authenticateOtsUser";

    var createShadowAccount = "rest/partialauth/ots/shadowAccount";

    return {
        getExistingUserOTS: function (data, skipExperian, referrerParam) {
            var deferred = $q.defer();

            $http
                .post(
                    __authenticationUrl__ + authenticateOTSUserURL + skipExperian + referrerParam,
                    data
                )
                .success(function (data) {
                    // Pass back the confirmation number
                    deferred.resolve(data);
                })
                .error(function (data) {
                    if (data !== null && data.error !== null) {
                        deferred.reject(data.error);
                    } else {
                        deferred.reject();
                    }
                });
            return deferred.promise;
        },
        createShadowAccountOTS: function (data) {
            var deferred = $q.defer();

            var shadowAccount = {
                phoneNumbers: [
                    {
                        countryCode: 9999,
                        phoneNumber: data,
                        phoneNumberType: "MOBILE"
                    }
                ]
            };
            $http
                .post(__authenticationUrl__ + createShadowAccount, shadowAccount)
                .success(function (data) {
                    deferred.resolve(data);
                })
                .error(function (data) {
                    if (data !== null && data.error !== null) {
                        deferred.reject(data.error);
                    } else {
                        deferred.reject();
                    }
                });
            return deferred.promise;
        }
    };
};
otsAccountOpenFactory.$inject = ["$q", "$http", "$log"];
export default otsAccountOpenFactory;
